import { useState } from "react";
import SubmitChatButton from "./SubmitChatButton";

const inputWrapClasses = "mb-1";

const inputClasses =
    "w-full min-h-18 resize-y border border-border rounded-lg " +
    "py-2.5 px-3 text-sm bg-white text-heading " +
    "placeholder:text-subtle";

const footerClasses = "flex justify-end items-center";

const ChatInputBox = ({ sendMessage, isLoading }) => {
    const [text, setText] = useState("");

    const handleSend = () => {
        if (!text.trim()) return;
        sendMessage(text);
        setText("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    return (
        <div className={inputWrapClasses}>
            <textarea
                className={inputClasses}
                placeholder="Ask ARCHES..."
                value={text}
                onChange={(e) => setText(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={isLoading}
            />
            <div className={footerClasses}>
                <SubmitChatButton onClick={handleSend} disabled={isLoading} />
            </div>
        </div>
    );
};

export default ChatInputBox;
